module.exports = __webpack_public_path__ + "media/images/arrow-right-5c53622e64d2b80f5669ce7d420222e4.png";